import { render, staticRenderFns } from "./UserDrawerSide.vue?vue&type=template&id=00a8d993&scoped=true&"
import script from "./UserDrawerSide.vue?vue&type=script&lang=js&"
export * from "./UserDrawerSide.vue?vue&type=script&lang=js&"
import style0 from "./UserDrawerSide.vue?vue&type=style&index=0&id=00a8d993&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a8d993",
  null
  
)

export default component.exports